import cn from 'classnames'
import { PropsWithChildren } from 'react'

import styles from './CoverageCard.module.scss'

interface ICoverageCardProps extends PropsWithChildren {
  className?: string
  variant: 'header' | 'table'
}

export const CoverageCard = ({ className, variant, children }: ICoverageCardProps) => (
  <div className={cn(styles.root, styles[variant], className)}>{children}</div>
)
